<template>
  <div>
    <div class="marginCenter">
      <div class="formTitle fsize24 fweight600 fcolor_black">
        护理个人基本信息
      </div>
      <el-form
        :model="form.applyBasic"
        inline
        label-position="right"
        class="form marginTop30"
        :rules="rules"
        ref="oneForm"
      >
        <div class="flex-sb jiben">
          <div class="left">
            <div class="marginBom24 pr">
              <img :src="form.applyBasic.portrait" alt="" />
              <span
                v-if="!form.applyBasic.portrait"
                class="pa fcolor_red"
                style="left: 50%; top: 50%; transform: translate(-50%, -50%)"
                >证件照必传</span
              >
            </div>
            <div class="flex-sb marginBom24">
              <FileUpload
                ref="upload"
                :isShowTip="false"
                class="avatar-uploader pr marginRt10"
                @on-success="uploadSuccess"
                id="1"
                multiple
                :before-upload="beforeAvatarUpload"
                :on-success="uploadSuccess"
                :fileType="['png', 'jpg', 'jpeg']"
              >
                <template #content>
                  <el-button
                    slot="trigger"
                    type="primary"
                    class="grayBtn"
                    style="width: 96px; height: 36px"
                    >上传</el-button
                  >
                </template>
              </FileUpload>
              <el-button
                type="primary"
                class="grayBtn"
                style="width: 96px; height: 36px"
                @click="clearFile"
                >删除</el-button
              >
            </div>
            <div>图片大小不超过5mb，图片 格式为(png、jpg、jpeg）</div>
            <div>一寸证件照，底色要求红色</div>
          </div>
          <div class="">
            <div class="flex-sb">
              <div class="middle">
                <div>
                  <el-form-item label="姓名：" label-width="200px">
                    <el-input
                      disabled
                      v-model="form.applyBasic.userName"
                      placeholder="请输入姓名"
                      style="width: 260px"
                    ></el-input>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item label="出生年月：" label-width="200px">
                    <el-input
                      placeholder="请输入"
                      disabled
                      :value="
                        $parent.user.idCard
                          ? $parent.user.idCard.slice(6, 10) +
                            '.' +
                            $parent.user.idCard.slice(10, 12)
                          : ''
                      "
                      style="width: 260px"
                    >
                    </el-input>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item
                    prop="education"
                    label="最高学历："
                    label-width="200px"
                  >
                    <el-select
                      v-model="form.applyBasic.education"
                      placeholder="请选择"
                      style="width: 260px"
                    >
                      <el-option
                        v-for="item in dict.type.education"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item
                    prop="nativePlace"
                    label="籍贯："
                    label-width="200px"
                  >
                    <el-cascader
                      clearable
                      v-model="nativePlaceArr"
                      :options="nativePlaceList"
                      :props="{ expandTrigger: 'hover', value: 'label' }"
                      @change="addressChange"
                      style="width: 260px"
                    ></el-cascader>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item
                    prop="jobTitle"
                    label="职称："
                    label-width="200px"
                  >
                    <el-select
                      v-model="form.applyBasic.jobTitle"
                      placeholder="请选择"
                      style="width: 260px"
                     
                    >
                      <el-option
                        v-for="item in dict.type.job_title"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item label="手机号：" label-width="200px">
                    <el-input
                      :value="$parent.user.phonenumber"
                      disabled
                      placeholder="请输入手机号"
                      style="width: 260px"
                    ></el-input>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item
                    prop="registeredScope"
                    label="紧急联系人姓名："
                    label-width="200px"
                  >
                    <el-input
                      v-model="form.applyBasic.emergencyContactName"
                      placeholder="请输入紧急联系人姓名"
                      style="width: 260px"
                    ></el-input>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item
                    prop="credentialsNo"
                    label="护士执业证书编号："
                    label-width="200px"
                  >
                    <el-input
                      v-model="form.applyBasic.credentialsNo"
                      placeholder="请输入执业资格证书编号"
                      style="width: 260px"
                    ></el-input>
                    <!-- <div class="fcolor_gray">（执业资格证号格式为24或27位）</div>
                                        <div class="fcolor_gray">（技术人员请填写技师证号码）</div> -->
                  </el-form-item>
                </div>
                <div>
                  <el-form-item
                    prop="selectionUnit"
                    label="选送工作单位："
                    label-width="200px"
                  >
                    <el-input
                      v-model="form.applyBasic.selectionUnit"
                      placeholder="请输入单位名称"
                      style="width: 260px"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="right">
                <div>
                  <el-form-item
                    prop="userSex"
                    label="性别："
                    label-width="200px"
                  >
                    <el-radio-group disabled v-model="$parent.user.sex">
                      <el-radio
                        v-for="item in dict.type.sys_user_sex"
                        :key="item.value"
                        :label="item.value"
                        >{{ item.raw.dictLabel }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item
                    prop="nation"
                    label="民族："
                    label-width="200px"
                  >
                    <el-select
                      v-model="form.applyBasic.nation"
                      placeholder="请选择"
                      style="width: 260px"
                    >
                      <el-option
                        v-for="item in dict.type.nation"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item
                    prop="politicalAffiliation"
                    label="政治面貌："
                    label-width="200px"
                  >
                    <el-select
                      v-model="form.applyBasic.politicalAffiliation"
                      placeholder="请选择"
                      style="width: 260px"
                    >
                      <el-option
                        v-for="item in dict.type.political_affiliation"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item
                    prop="healthStatus"
                    label="健康状况："
                    label-width="200px"
                  >
                    <el-select
                      v-model="form.applyBasic.healthStatus"
                      placeholder="请选择"
                      style="width: 260px"
                    >
                      <el-option
                        v-for="item in dict.type.health_status"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item prop="post" label="职务：" label-width="200px">
                    <el-select
                      v-model="form.applyBasic.post"
                      placeholder="请选择"
                      style="width: 260px"
                       @change="trainDirectionChange"
                    >
                      <el-option
                        v-for="item in dict.type.nursing_title"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item label="身份证号：" label-width="200px">
                    <el-input
                      :value="$parent.user.idCard"
                      disabled
                      placeholder="请输入身份证号"
                      style="width: 260px"
                    ></el-input>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item label="紧急联系人电话：" label-width="200px">
                    <el-input
                      v-model="form.applyBasic.emergencyContactPhone"
                      placeholder="请输入紧急联系人电话"
                      style="width: 260px"
                    ></el-input>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item
                    label="护士执业证书有效期："
                    label-width="200px"
                  >
                    <el-date-picker
                      v-model="form.applyBasic.credentialsTerm"
                      type="date"
                      placeholder="选择日期"
                      style="width: 260px"
                    >
                    </el-date-picker>
                    <!-- <div class="fcolor_gray">（执业注册证号格式为15位）</div> -->
                  </el-form-item>
                </div>
                <div>
                  <el-form-item
                    prop="selectionDept"
                    label="选送工作科室："
                    label-width="200px"
                  >
                    <el-input
                      v-model="form.applyBasic.selectionDept"
                      placeholder="请输入工作科室"
                      style="width: 260px"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="registeredPlace">
              <el-form-item
                prop="selectionPlace"
                label="选送单位地址："
                label-width="200px"
                style="width: 100%; display: flex !important"
              >
                <el-input
                  v-model="form.applyBasic.selectionPlace"
                  placeholder="请按照“xx省xx市xx区xx路xx号”规则填写"
                  style="flex-grow: 1"
                  maxlength="19"
                >
                </el-input>
              </el-form-item>
            </div>
            <div class="flex-sb">
              <div class="middle">
                <div>
                  <el-form-item
                    prop="hospitalLevel"
                    label="选送医院等级："
                    label-width="200px"
                    class="flex"
                  >
                    <el-select
                      v-model="form.applyBasic.hospitalLevel"
                      placeholder="请选择"
                      style="width: 260px"
                    >
                      <el-option
                        v-for="item in dict.type.hospital_level"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item
                    prop="depositBank"
                    label="开户银行："
                    label-width="200px"
                  >
                    <el-select
                      v-model="form.applyBasic.depositBank"
                      placeholder="请选择"
                      style="width: 260px"
                      clearable
                    >
                      <el-option
                        v-for="item in dict.type.deposit_bank"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="right">
                <div>
                  <el-form-item
                    prop="selectionPhone"
                    label="护理部电子邮箱："
                    label-width="200px"
                  >
                    <el-input
                      v-model="form.applyBasic.selectionPhone"
                      placeholder="请输入护理部电子邮箱"
                      style="width: 260px"
                    ></el-input>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item
                    prop="bankNo"
                    label="银行卡号："
                    label-width="200px"
                  >
                    <el-input
                      v-model="form.applyBasic.bankNo"
                      placeholder="请输入本人银行卡号"
                      style="width: 260px"
                      maxlength="19"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="study flex-sb">
          <div class="right"></div>
        </div>
        <div class="overflow staging marginBom30">
          <el-button class="fr blueBtn2 btn300" type="primary" @click="staging"
            >保存此页信息</el-button
          >
        </div>
        <div class="footer fr">
          <a
            class="a backIndex active fcolor_blue2 fsize22"
            @click="goPage(2)"
            >1</a
          ><a
            class="a backIndex fcolor_blue2 fsize22"
            @click="goPage(3)"
            >2</a
          ><a
            class="a backIndex fcolor_blue2 fsize22"
            @click="goPage(4)"
            >3</a
          >
          <a
            class="a backIndex fcolor_blue2 fsize22"
            @click="goPage(3)"
            >下一页</a
          >
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
// import nativePlace from "@/views/json/nativePlace.json"
import { getToken } from "@/utils/auth";
import { getApplyStorage, setStorageNurseApplyInfo } from "@/utils/api";
import { regionData, provinceAndCityData } from "element-china-area-data";
export default {
  dicts: [
    "political_affiliation",
    "deposit_bank",
    "job_title",
    "tuberculosis",
    "sys_user_sex",
    "nation",
    "education",
    "health_status",
    "pestilence",
    "hospital_level",
    "nursing_title"
  ],
  data() {
    return {
      form: this.$parent.nurseForm,
      headers: {
        Authorization: "Bearer " + getToken(),
      },
      nativePlaceList: regionData,
      nativePlaceArr: [], //籍贯
      provinceAndCityList: provinceAndCityData,
      rules: {
        education: {
          required: true,
          trigger: "change",
          message: "最高学历不能为空",
        },
        nativePlace: {
          required: true,
          trigger: "change",
          message: "籍贯不能为空",
        },
        jobTitle: {
          required: true,
          trigger: "change",
          message: "职称不能为空",
        },
        selectionUnit: {
          required: true,
          trigger: "blur",
          message: "选送工作单位不能为空",
        },
        hospitalLevel: {
          required: true,
          trigger: "change",
          message: "选送医院等级不能为空",
        },
        nation: { required: true, trigger: "change", message: "民族不能为空" },
        politicalAffiliation: {
          required: true,
          trigger: "change",
          message: "政治面貌不能为空",
        },
        healthStatus: {
          required: true,
          trigger: "change",
          message: "健康状况不能为空",
        },
        post: { required: true, trigger: "blur", message: "职务不能为空" },
        selectionDept: {
          required: true,
          trigger: "blur",
          message: "选送工作科室不能为空",
        },
        selectionPhone: {
          required: true,
          trigger: "blur",
          message: "选送单位医教科电话不能为空",
        },
        selectionPlace: {
          required: true,
          trigger: "blur",
          message: "选送单位地址不能为空",
        },
      },
    };
  },
  created() {
    if (this.form.applyBasic.nativePlace != null) {
      this.nativePlaceArr = this.form.applyBasic.nativePlace.split("-");
    }
    this.form.applyBasic.userName = this.$parent.user.userName;
    this.form.applyBasic.userSex = this.$parent.user.sex;
  },
  methods: {
   async goPage(val){
      // 校验证件照是否已上传
      if (!this.form.applyBasic.portrait) {
        this.$message.error('请上传证件照');
        return;
      }
      await this.staging()
      this.$parent.active = val
    },
    trainDirectionChange(){
      this.form.applyDeptList[0] = {
        trainDirection: "",
        deptId: "",
        trainDuration: "",
        trainDuration2: "",
        month: null,
      }
    },
    //
    addressChange(arr) {
      //籍贯省市区名称
      this.form.applyBasic.nativePlace = `${arr
        .toString()
        .replaceAll(",", "-")}`;
    },
   async staging() {
       await setStorageNurseApplyInfo(this.form)
       this.$message.success("暂存信息成功");
    },
    // 文件上传前
    beforeAvatarUpload(file) {
      let typeList = ["image/jpeg", "image/png", "image/jpg"];
      const isJPG = typeList.includes(file.type);
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG与PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // 上传文件成功时
    uploadSuccess(res, file, list) {
      console.log(res, file, list);
      this.$set(this.form.applyBasic, "portrait", res.url);
    },
    // 删除图片
    clearFile() {
      // this.$refs.upload.clearFiles();
      this.form.applyBasic.portrait = "";
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-form-item__label {
  font-size: 18px !important;
}

::v-deep .registeredPlace .el-form-item__content {
  flex-grow: 1;
}

.backIndex:hover {
  cursor: pointer;
}

.formTitle {
  margin: 50px 0px 30px 240px;
}

::v-deep.form {
  margin-bottom: 47px;
  overflow: hidden;

  .el-form-item__label {
    color: #333;
    font-size: 22px;
    padding: 0;
  }

  .jiben .left {
    // margin-right: 38px;
    width: 206px;

    & > div:nth-child(1) {
      & > img {
        width: 100%;
        height: 252px;
      }
    }
  }

  .study {
    padding: 0 0 0 240px;
    margin-bottom: 40px;
  }

  .footer {
    .a {
      display: inline-block;
      width: 40px;
      line-height: 36px;
      text-align: center;
      border-radius: 5px;
      height: 40px;
      color: #333;
      border: #999999 solid 2px;
      margin-left: 30px;

      &:hover {
        border-color: #2d53c8;
      }
    }

    & > .a:last-child {
      width: 110px;
    }

    & > .active {
      border-color: #2d53c8;
    }
  }
}
</style>
